export const GET_ALL_PROCEDURES_API = "doctor/get-all-procedures";
export const UPDATE_PATIENT_INFO = "public/update-patient-details";
export const GET_PATIENT_INFO = "user/get-patient-account-info";
export const UPDATE_PATIENT_ADDRESS_INFO = "user/update-patient-info";
export const GET_STATE_CITY = "/public/get-city";
export const GET_UHID_LIST = (clinic_id) =>
  `/api/v1/${clinic_id}/check_patient_uhid`;
